;(function () {
  'use strict'

  angular
    .module('contrast.highcharts')
    .factory(
      'highchartsTooltipBuilderService',
      function highchartsTooltipBuilderServiceFactory(
        Highcharts,
        HIGHCHARTS_COLORS
      ) {
        'ngInject'

        return {
          buildTooltipConfig: buildTooltipConfig,
          setTooltipBg: setTooltipBg,
          setTooltipBgEqualsToSeriesColor: setTooltipBgEqualsToSeriesColor
        }

        function buildTooltipConfig() {
          return {
            borderRadius: 8,
            padding: 0,
            borderWidth: 0,
            shadow: false,
            shape: 'callout',
            useHTML: true
          }
        }

        function setTooltipBg(
          tooltipConfig,
          drilldownSeriesId,
          backgroundColor
        ) {
          var customBackgroundColor = 'seriesColor'
          tooltipConfig.backgroundColor = customBackgroundColor

          Highcharts.wrap(
            Highcharts.Tooltip.prototype,
            'refresh',
            function (p, point, mouseEvents) {
              p.call(this, point, mouseEvents)

              var label = this.label

              if (
                this.options.backgroundColor === customBackgroundColor &&
                point &&
                label &&
                point.series.options.id === drilldownSeriesId
              ) {
                label.attr({
                  fill: HIGHCHARTS_COLORS.DRILLDOWN_TOOLTIP_BACKGROUND
                })
              } else if (
                this.options.backgroundColor === customBackgroundColor &&
                point &&
                label
              ) {
                label.attr({
                  fill: backgroundColor
                })
              }
            }
          )
        }

        /* Tooltips background
         * Wrapping Tooltip.refresh() method in order to change the tooltip's background according to the point's series color.
         * Reference: https://stackoverflow.com/questions/42772038/highcharts-tooltip-background-according-to-line-without-setting-backgroundcolor
         */
        function setTooltipBgEqualsToSeriesColor(
          tooltipConfig,
          drilldownSeriesId
        ) {
          var customBackgroundColor = 'seriesColor'
          tooltipConfig.backgroundColor = customBackgroundColor

          Highcharts.wrap(
            Highcharts.Tooltip.prototype,
            'refresh',
            function (p, point, mouseEvents) {
              p.call(this, point, mouseEvents)

              var label = this.label

              if (
                this.options.backgroundColor === customBackgroundColor &&
                point &&
                label
              ) {
                if (point.series.options.id === drilldownSeriesId) {
                  label.attr({
                    fill: HIGHCHARTS_COLORS.DRILLDOWN_TOOLTIP_BACKGROUND
                  })
                } else {
                  label.attr({
                    fill: point.series.color
                  })
                }
              }
            }
          )
        }
      }
    )
})()
